import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from '../../util/types';
import { Slider, ListingCard } from '../../components';
import classNames from 'classnames';

import css from './SectionListings.module.css';

// slidesToShow
const SLIDES_TO_SHOW_TABLET = 3;
const SLIDES_TO_SHOW_DESKTOP = 5;
// slidesToScroll
const SLIDES_TO_SCROLL_TABLET = 3;
const SLIDES_TO_SCROLL_DESKTOP = 3;

const SectionListings = props => {
  const {
    rootClassName,
    className,
    titleClassName,
    arrowsClassName,
    intl,
    listings,
    queryListingsInProgress,
    queryListingsError,
    slidesToShow,
    slidesToScroll,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const titleClasses = classNames(css.title, titleClassName);

  // Hide only when there's nothing to show. After SSR hydration the
  // client re-runs loadData, flipping queryListingsInProgress — the
  // server-rendered slider must stay on screen through that refetch
  // instead of unmounting (the "sections vanish then reappear" flash).
  if (queryListingsError || (queryListingsInProgress && (!listings || listings.length === 0))) {
    return null;
  }

  const sliderTitle = intl.formatMessage({ id: 'SectionListings.title' });
  return (
    <div className={classes}>
      <Slider
        id="LandingPage.listingsSlider"
        headerClassName={css.header}
        titleClassName={titleClasses}
        title={sliderTitle}
        itemClassName={css.sliderItem}
        arrowsClassName={arrowsClassName}
        slidesToShow={{
          tablet: slidesToShow?.tablet || SLIDES_TO_SHOW_TABLET,
          desktop: slidesToShow?.desktop || SLIDES_TO_SHOW_DESKTOP,
        }}
        slidesToScroll={{
          tablet: slidesToScroll?.tablet || SLIDES_TO_SCROLL_TABLET,
          desktop: slidesToScroll?.desktop || SLIDES_TO_SCROLL_DESKTOP,
        }}
      >
        {listings.map(l => {
          return <ListingCard key={l.id.uuid} listing={l} />;
        })}
      </Slider>
    </div>
  );
};

SectionListings.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  arrowsClassName: null,
  queryListingsInProgress: false,
  queryListingsError: null,
};

const { arrayOf, bool, string } = PropTypes;

SectionListings.propTypes = {
  rootClassName: string,
  className: string,
  titleClassName: string,
  arrowsClassName: string,

  listings: arrayOf(propTypes.listing),
  queryListingsInProgress: bool.isRequired,
  queryListingsError: propTypes.error,
};

export default SectionListings;
